import * as React from 'react';
import { Input, Radio } from 'antd';
import I18N from 'src/services/I18NService';

/**
 * 包邮设置数据结构
 *
 * @export
 * @interface IFreightFreeConditionData
 */
export interface IFreightFreeConditionData {
  /** 是否包邮 */
  enable: boolean;
  /** 满多少元包邮 */
  fee?: number;
}

interface IFreightFreeConditionProps {
  /** 传入的数据 */
  value?: IFreightFreeConditionData;
  /** 回调 */
  onChange?: (value: IFreightFreeConditionData) => void;
}

interface IFreightFreeConditionState {
  /** 包邮金额 */
  feeStr: string | undefined;
}

class FreightFreeCondition extends React.Component<IFreightFreeConditionProps, IFreightFreeConditionState> {
  constructor(props: IFreightFreeConditionProps) {
    super(props);

    let feeStr = '';
    if (!!props.value && props.value.fee !== undefined) {
      feeStr = props.value.fee.toString();
    }
    this.state = {
      feeStr,
    };
  }

  /**
   * 是否包邮 变更时回调
   *
   * @memberof FreightFreeCondition
   */
  enableChange = (e: any) => {
    const enable = e.target.value;
    if (!enable) {
      this.triggerChange({ enable, fee: undefined });
    } else {
      this.triggerChange({ enable });
    }
  };

  /**
   * 值改变时触发
   *
   * @memberof DecoctionFeeSetting
   */
  feeChange = (e: any) => {
    try {
      let feeStr = e.target.value as string;
      feeStr = feeStr.replace(/。/g, '.');
      feeStr = feeStr.replace(/[^0-9.]/gi, '');

      const numArr = feeStr.split('.');
      if (numArr.length > 2) {
        return;
      }

      if (numArr.length > 1) {
        if (feeStr.endsWith('.')) {
          feeStr = `${feeStr}0`;
          if (isNaN(parseFloat(feeStr))) {
            return;
          }
          this.setState({
            feeStr: e.target.value,
          });
          return;
        } else {
          feeStr = `${numArr[0]}.${numArr[1].substr(0, 2)}`;
        }
      }

      if (numArr[0].trim() !== '' && isNaN(parseFloat(feeStr))) {
        return;
      }
      this.setState({
        feeStr,
      });
    } catch (error) {
      console.error(error);
    }
  };

  /**
   * 失去焦点时触发
   *
   * @memberof DecoctionFeeSetting
   */
  feeBlur = () => {
    const fee = this.state.feeStr !== undefined && this.state.feeStr !== '' ? Number(this.state.feeStr) : undefined;
    this.triggerChange({ fee, enable: true });
  };

  triggerChange = (changedValue: IFreightFreeConditionData) => {
    const { onChange, value } = this.props;
    if (onChange) {
      onChange({
        ...value,
        ...changedValue,
      });
    }
  };

  render() {
    const { value } = this.props;
    const statusEnable = !!value ? value.enable : false;
    return (
      <span>
        <Radio.Group onChange={this.enableChange} value={statusEnable}>
          <Radio value={false}>{I18N.get('common_status_not_start')}</Radio>
          <Radio value={true}>{I18N.get('common_status_start')}</Radio>
        </Radio.Group>
        {statusEnable && (
          <React.Fragment>
            <span style={{ width: '5%', textAlign: 'center', lineHeight: '32px', display: 'inline-block' }}>
              {I18N.get('setting_fee_template_free_condition_prefix')}
            </span>
            <Input
              min={0}
              value={this.state.feeStr}
              onChange={this.feeChange}
              onBlur={this.feeBlur}
              placeholder={`${I18N.get('common_input')}`}
              style={{ width: '25%' }}
            />
            <span style={{ width: '10%', textAlign: 'center', lineHeight: '32px', display: 'inline-block' }}>
              {I18N.get('setting_fee_template_free_condition_suffix')}
            </span>
          </React.Fragment>
        )}
      </span>
    );
  }
}

export default FreightFreeCondition;



// WEBPACK FOOTER //
// ./src/components/views/Setting/FreightFreeCondition.tsx